(function($) {
	formHelper.addRule({
		form: '.form-search-evs1-risk-mitigation-report',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);


jQuery(function initToolsSearchEvs1RiskMitigationReport($) {
	$('.search-evs1-risk-mitigation-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-evs1-risk-mitigation-report');

		// Date confirmation Range
		// ------------------
		var $confDateStart = $('#confirmation-date-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var confDateStartPicker = $confDateStart.pickadate('picker');

		var $confDateEnd = $('#confirmation-date-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var confDateEndPicker = $confDateEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( confDateStartPicker.get('value') ) {
			confDateEndPicker.set('min', confDateStartPicker.get('select'));
		}
		
		if ( confDateEndPicker.get('value') ) {
			confDateStartPicker.set('max', confDateEndPicker.get('select'));
		}

		// When something is selected, update the "confDateStart" and "confDateEnd" limits.
		confDateStartPicker.on('set', function(event) {
			if ( event.select ) {
				confDateEndPicker.set('min', confDateStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				confDateEndPicker.set('min', false);
			}
		});

		confDateEndPicker.on('set', function(event) {
			if ( event.select ) {
				confDateStartPicker.set('max', confDateEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				confDateStartPicker.set('max', false);
			}
		});

		// Date cancellation Range
		// ------------------
		var $cancelDateStart = $('#cancellation-date-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var cancelDateStartPicker = $cancelDateStart.pickadate('picker');

		var $cancelDateEnd = $('#cancellation-date-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var cancelDateEndPicker = $cancelDateEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( cancelDateStartPicker.get('value') ) {
			cancelDateEndPicker.set('min', cancelDateStartPicker.get('select'));
		}
		
		if ( cancelDateEndPicker.get('value') ) {
			cancelDateStartPicker.set('max', cancelDateEndPicker.get('select'));
		}

		// When something is selected, update the "cancelDateStart" and "cancelDateEnd" limits.
		cancelDateStartPicker.on('set', function(event) {
			if ( event.select ) {
				cancelDateEndPicker.set('min', cancelDateStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				cancelDateEndPicker.set('min', false);
			}
		});

		cancelDateEndPicker.on('set', function(event) {
			if ( event.select ) {
				cancelDateStartPicker.set('max', cancelDateEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				cancelDateStartPicker.set('max', false);
			}
		});
	});
});

jQuery(function initToolsEvsRiskMitigationResults($) {
	$('.search-evs1-risk-mitigation-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-evs1-risk-mitigation-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});